// extracted by mini-css-extract-plugin
export default {"v-hackster":"var(--hackster)","container":"hckui__nav-tabbed__container","tab":"hckui__nav-tabbed__tab","active":"hckui__nav-tabbed__active"};